import { getType, toString, getProperty } from './DebugUtil';
/*
 * 크롬처럼 object 내용을 보여줌
 * 클래스명이 길어서 _debug_object를 _d_o로 표시
 * 구조
   <Property>
       <PropertyList>
           <Property>
               <PropertyList>
           <Property>
           <Property>
           ...
       </PropertyList>
   <Property>
 */

/**
 * <PropertyList> html 반환
 * @param sPath
 * @returns {string}
 */
function getPropertyListHtml(sPath) {
  return `<div class="_d_o_property_list" data-parent-object="${sPath}"></div>`;
}

/**
 * <Property> html 반환
 * @param key
 * @param value
 * @param type
 * @returns {string}
 */
function getPropertyHtml(key, value, type) {
  return `<div class="_d_o_property" data-value-type="${type}">
        <div class="_d_o_inner_wrapper">
            <span class="_d_o_status">&#9654</span>
            ${key ? `<span class="_d_o_key">${key}</span>` : ''}
            <span class="_d_o_value">${value}</span>
        </div>
    </div>`;
}

/**
 * <Property>를 생성해서 부모 element에 추가 한 후 반환한다
 * @param elParent(welParent)
 * @param property: any
 * @param propertyName
 */
function renderProperty(elParent, property, propertyName = '') {
  const sPropertyHtml = getPropertyHtml(
    propertyName,
    toString(property),
    getType(property)
  );
  return $(sPropertyHtml).appendTo(elParent);
}

class DebugObject {
  constructor(elWrapper, oTarget) {
    this.welWrapper = $(elWrapper);

    // root 프로퍼티 element를 생성한다(root는 key가 없다)
    this.welRootProperty = renderProperty(elWrapper, oTarget);

    // target 객체를 캐시한다
    this.sRootKey = 'root';
    this[this.sRootKey] = oTarget;
    this.setEvent();
  }

  /**
   * 클릭된 property의 정보를 보여주는 element를 생성한다
   * @param welTarget
   */
  createSubList(welTarget) {
    const welParent = welTarget.closest('._d_o_property_list');
    const sTargetKey = welTarget.find('._d_o_key').text();

    // 인스턴스를 생성할 때 지정한 object 까지의 경로
    const sPath = `${
      welParent.length ? `${welParent.data('parentObject')}.` : ''
    }${sTargetKey || this.sRootKey}`;
    // 리스트 wrapper element 반환(data-value-parent에 path를 지정해서 target object를 알아낼 때 사용)
    const welSubList = $(getPropertyListHtml(sPath));

    // object내의 요소를 순회하면서 리스트를 채움
    const oTarget = getProperty(this, sPath);
    const aKey = Object.keys(oTarget);
    for (const item of aKey) {
      renderProperty(welSubList, oTarget[item], item);
    }
    welSubList.appendTo(welTarget);
  }

  setEvent() {
    this.welWrapper.on(
      'click',
      '._d_o_property[data-value-type=object] > ._d_o_inner_wrapper',
      e => {
        this.toggleProperty(e);
      }
    );
  }

  /**
   * property를 클릭하면 정보를 보여주거나 감춘다
   * @param e
   */
  toggleProperty(e) {
    e.stopPropagation();
    const welTarget = $(e.currentTarget).closest('._d_o_property');

    if (welTarget.hasClass('expanded')) {
      welTarget.removeClass('expanded');
      return;
    }

    if (welTarget.children('._d_o_property_list').length === 0) {
      this.createSubList(welTarget);
    }
    welTarget.addClass('expanded');
  }

  /**
   * 현재 인스턴스가 생성한 element를 제거한다.
   */
  destroy() {
    this.welRootProperty.remove();
  }
}

export default DebugObject;
